import { type RouteRecordRaw, createRouter } from 'vue-router'
import { history } from './reconstruct'
// 常量
import {
  CLINIC,
  COMMON,
  DICT,
  EMPLOYEE,
  LIST,
  CONFIG,
  // SOURCE,
  SLOT,
  PROJECT,
  ACUPUNCTURE,
  BONING,
  CUPPING,
  ROLE,
  USER,
  PATIENT,
  PROMOTION,
  PROXY,
  MEDICATION,
  INVENTORY,
  PROCUREMENT,
  STOCKTAKING,
  ADJUSTMENT,
  REVENUE,
  FEE,
  DISCOUNT,
  COUPON,
  EVENTS,
  CLIENT,
  SETMEAL,
  DISEASE,
  RETAIL,
  DRUG,
  ACTIVITIES,
  STATISTICS,
  PRINTRECORD,
  LOG,
  LOGINLOG,
  SUMMARY,
  TRACKING,
} from '@/common/src/router/constant'

const Layouts = () => import('@/layouts/index.vue')
// 常量
/**
 * 常驻路由
 * 除了 redirect/403/404/login 等隐藏页面，其他页面建议设置 Name 属性
 */
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/403',
    component: () => retryImport('403'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/404',
    component: () => retryImport('404'),
    meta: {
      hidden: true,
    },
    alias: '/:pathMatch(.*)*',
  },
  {
    path: '/login',
    component: () => retryImport('login'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/',
    component: Layouts,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => retryImport('home'),
        name: 'Home',
        meta: {
          title: 'Title_Common.ShouYe', // '首页',
          svgIcon: 'home',
          affix: true,
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*', // Must put the 'ErrorPage' route at the end, 必须将 'ErrorPage' 路由放在最后
    redirect: '/404',
    name: 'ErrorPage',
    meta: {
      hidden: true,
    },
  },
]

/**
 * 动态路由
 * 用来放置有权限 (Roles 属性) 的路由
 * 必须带有 Name 属性
 */
export const asyncRoutes: RouteRecordRaw[] = [
  {
    path: `/${CLINIC}`,
    component: Layouts,
    redirect: `/${CLINIC}/${LIST}`,
    name: 'Clinic',
    meta: {
      title: 'Title_Common.ZhenSuo_GuanLi', // '诊所管理',
      svgIcon: 'clinic',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
    },
    children: [
      {
        path: `${LIST}`,
        component: () => retryImport(`${CLINIC}-${LIST}`),
        name: 'ClinicList',
        meta: {
          title: 'Title_Common.ZhenSuo_LieBiao', // '诊所列表',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      // {
      //   path: `${CONFIG}`,
      //   component: () => retryImport(`${CLINIC}-${CONFIG}`),
      //   name: 'ClinicConfig',
      //   meta: {
      //     title: 'Title_Common.ZhenSuo_PeiZhi', // '诊所配置',
      //     roles: ['admin'], // 或者在子导航中设置角色
      //   },
      // },
      // {
      //   path: `${SOURCE}`,
      //   component: () => retryImport(`${CLINIC}-${SOURCE}`),
      //   name: 'ClinicSource',
      //   meta: {
      //     title: 'Title_Common.HaoYuan_GuiZe', // '号源规则',
      //     roles: ['admin'], // 或者在子导航中设置角色
      //   },
      // },
      {
        path: `${SLOT}`,
        component: () => retryImport(`${CLINIC}-${SLOT}`),
        name: 'ClinicSlot',
        meta: {
          title: 'Title_Common.HaoYuan_PaiBan', // '號源排班',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${ROLE}`,
        component: () => retryImport(`${CLINIC}-${ROLE}`),
        name: 'ClinicRole',
        meta: {
          title: 'Title_Common.JueSe_QuanXian', // '角色權限',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
    ],
  },
  {
    path: `/${USER}`,
    component: Layouts,
    redirect: `/${USER}/${EMPLOYEE}`,
    name: 'User',
    meta: {
      title: 'Title_Common.YongHu_GuanLi', // '用戶管理',
      svgIcon: 'user',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
      // controlled: true, // 模塊是否受權限控制
    },
    children: [
      {
        path: `${EMPLOYEE}`,
        component: () => retryImport(`${USER}-${EMPLOYEE}`),
        name: 'UserEmployee',
        meta: {
          title: 'Title_Common.YuanGong_XinXi', // '員工信息',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${PATIENT}`,
        component: () => retryImport(`${USER}-${PATIENT}`),
        name: 'UserPatient',
        meta: {
          title: 'Title_Common.HuanZhe_LiBiao', // '患者列表',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${PROMOTION}`,
        component: () => retryImport(`${USER}-${PROMOTION}`),
        name: 'UserPromotion',
        meta: {
          title: 'Title_Common.ZhuanJieMa', // '轉介碼',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${PROXY}`,
        component: () => retryImport(`${USER}-${PROXY}`),
        name: 'UserProxy',
        meta: {
          title: 'Title_Common.ShouQuan_GuanLi', // '授權管理',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      // {
      //   path: `${COMMON}`,
      //   component: () => retryImport(`${USER}-${COMMON}`),
      //   name: 'UserCommon',
      //   meta: {
      //     title: 'Title_Common.ChangYong_SheDing', // '常用設定',
      //     roles: ['admin'], // 或者在子导航中设置角色
      //   },
      // },
    ],
  },
  {
    path: `/${REVENUE}`,
    component: Layouts,
    redirect: `/${REVENUE}/${FEE}`,
    name: 'Revenue',
    meta: {
      title: 'Title_Common.YingShou_GuanLi', // '營收管理',
      svgIcon: 'fee',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
      // controlled: true, // 模塊是否受權限控制
    },
    children: [
      {
        path: `${FEE}`,
        component: () => retryImport(`${REVENUE}-${FEE}`),
        name: 'RevenueFee',
        meta: {
          title: 'Title_Common.ShouFei_SheDing', // '收費設定',
          roles: ['admin'], // 或者在子导航中设置角色
          // controlled: true, // 模塊是否受權限控制
        },
      },
    ],
  },
  {
    path: `/${MEDICATION}`,
    component: Layouts,
    redirect: `/${MEDICATION}/${LIST}`,
    name: 'Medication',
    meta: {
      title: 'Title_Common.YaoPin_GuanLi', // '藥品管理',
      svgIcon: 'inventory',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
    },
    children: [
      {
        path: `${LIST}`,
        component: () => retryImport(`${MEDICATION}-${LIST}`),
        name: 'MedicationList',
        meta: {
          title: 'Title_Common.YaoPin_LieBiao', // '藥品列表',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${INVENTORY}`,
        component: () => retryImport(`${MEDICATION}-${INVENTORY}`),
        name: 'MedicationInventory',
        meta: {
          title: 'Title_Common.YaoPin_KuCun', // '藥品庫存',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${PROCUREMENT}`,
        component: () => retryImport(`${MEDICATION}-${PROCUREMENT}`),
        name: 'MedicationProcurement',
        meta: {
          title: 'Title_Common.YaoPin_CaiGou', // '藥品採購',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${STOCKTAKING}`,
        component: () => retryImport(`${MEDICATION}-${STOCKTAKING}`),
        name: 'MedicationStocktaking',
        meta: {
          title: 'Title_Common.YaoPin_PanDian', // '藥品盤點',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${ADJUSTMENT}`,
        component: () => retryImport(`${MEDICATION}-${ADJUSTMENT}`),
        name: 'MedicationAdjustment',
        meta: {
          title: 'Title_Common.YaoPin_TiaoZheng', // '藥品調整',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${TRACKING}`,
        component: () => retryImport(`${MEDICATION}-${TRACKING}`),
        name: 'MedicationTracking',
        meta: {
          title: 'Title_Common.KuCun_ZhuiZong', // '庫存追蹤',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
    ],
  },
  {
    path: `/${RETAIL}`,
    component: Layouts,
    redirect: `/${RETAIL}/${DRUG}`,
    name: 'Retail',
    meta: {
      title: 'Title_Common.ZhenSuo_LingShou', // '診所零售',
      svgIcon: 'retail',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
    },
    children: [
      {
        path: `${DRUG}`,
        component: () => retryImport(`${RETAIL}-${DRUG}`),
        name: 'RetailDrug',
        meta: {
          title: 'Title_Common.YaoPin_LingShou', // '藥品零售',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${ACTIVITIES}`,
        component: () => retryImport(`${RETAIL}-${ACTIVITIES}`),
        name: 'RetailActivities',
        meta: {
          title: 'Title_Common.LingShou_HuoDong', // '零售活動',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
    ],
  },
  {
    path: `/${PROJECT}`,
    component: Layouts,
    redirect: `/${PROJECT}/${ACUPUNCTURE}`,
    name: 'Project',
    meta: {
      title: 'Title_Common.XiangMu_GuanLi', // '項目管理',
      svgIcon: 'project',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
    },
    children: [
      {
        path: `${ACUPUNCTURE}`,
        component: () => retryImport(`${PROJECT}-${ACUPUNCTURE}`),
        name: 'ProjectAcupuncture',
        meta: {
          title: 'Title_Common.ZhenJiu_GuanLi', // '針灸管理',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${BONING}`,
        component: () => retryImport(`${PROJECT}-${BONING}`),
        name: 'ProjectBoning',
        meta: {
          title: 'Title_Common.TuiNa_ZhengGu', // '推拿/正骨',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${CUPPING}`,
        component: () => retryImport(`${PROJECT}-${CUPPING}`),
        name: 'ProjectCupping',
        meta: {
          title: 'Title_Common.BaGuan_GuanLi', // '拔罐管理',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${DISEASE}`,
        component: () => retryImport(`${PROJECT}-${DISEASE}`),
        name: 'ProjectDisease',
        meta: {
          title: 'Title_Common.PiPei_YaoWu', // '匹配藥物',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
    ],
  },
  {
    path: `/${DISCOUNT}`,
    component: Layouts,
    redirect: `/${DISCOUNT}/${COUPON}`,
    name: 'Discount',
    meta: {
      title: 'Title_Common.YouHui_GuanLi', // '优惠管理',
      svgIcon: 'discount',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
    },
    children: [
      {
        path: `${COUPON}`,
        component: () => retryImport(`${DISCOUNT}-${COUPON}`),
        name: 'ClinicCoupon',
        meta: {
          title: 'Title_Common.YouHuiQuan', // '優惠券',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${SETMEAL}`,
        component: () => retryImport(`${DISCOUNT}-${SETMEAL}`),
        name: 'ClinicSetmeal',
        meta: {
          title: 'Title_Common.TaoPiao_GuanLi', // '套票管理',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${EVENTS}`,
        component: () => retryImport(`${DISCOUNT}-${EVENTS}`),
        name: 'DiscountEvents',
        meta: {
          title: 'Title_Common.ChuZhi_HuoDong', // '儲值活動',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${CLIENT}`,
        component: () => retryImport(`${DISCOUNT}-${CLIENT}`),
        name: 'DiscountClient',
        meta: {
          title: 'Title_Common.ChuZhi_YongHu', // '儲值用戶',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
    ],
  },
  {
    path: `/data`,
    component: Layouts,
    redirect: `/data/acupunctureMethod`,
    name: 'Data',
    meta: {
      title: 'Title_Common.Gonggong_Shuju', // '公共数据',
      svgIcon: 'system',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
    },
    children: [
      {
        path: `acupunctureMethod`,
        component: () => retryImport(`data-acupunctureMethod`),
        name: 'DataAcupunctureMethod',
        meta: {
          title: 'Title_Common.ZhenJiu_FanFa', // '针灸方法',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `acupuncturePosition`,
        component: () => retryImport(`data-acupuncturePosition`),
        name: 'DataAcupuncturePosition',
        meta: {
          title: 'Title_Common.ZhenJiu_WeiZhi', // '针灸位置',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `medicantFunc`,
        component: () => retryImport(`data-medicantFunc`),
        name: 'DataMedicantFunc',
        meta: {
          title: 'Title_Common.YaoPing_GongNeng', // '药品功能',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `medicantBrand`,
        component: () => retryImport(`data-medicantBrand`),
        name: 'DataMedicantBrand',
        meta: {
          title: 'Title_Common.YaoPing_PingPai', // '药品品牌',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `payMethod`,
        component: () => retryImport(`data-payMethod`),
        name: 'DataPayMethod',
        meta: {
          title: 'Title_Common.ZhiFu_FangShi', // '支付方式',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `memberType`,
        component: () => retryImport(`data-memberType`),
        name: 'DataMemberType',
        meta: {
          title: 'Title_Common.HuiYuan_LeiBie', // '会员类别',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `labexamType`,
        component: () => retryImport(`data-labexamType`),
        name: 'DataLabexamType',
        meta: {
          title: 'Title_Common.HuaYan_LeiXing', // '化验类型',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `labexam`,
        component: () => retryImport(`data-labexam`),
        name: 'DataLabExamIndicator',
        meta: {
          title: 'Title_Common.HuaYan_ZhiBiao', // '化验指标',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `exclusion`,
        component: () => retryImport(`data-exclusion`),
        name: 'DataExclusion',
        meta: {
          title: 'Title_Common.YaoWu_HuChi', // '配伍禁忌',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `sensitive`,
        component: () => retryImport(`data-sensitive`),
        name: 'DataSensitive',
        meta: {
          title: 'Title_Common.MinGan_JinJi', // '敏感禁忌',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
    ],
  },
  {
    path: `/${STATISTICS}`,
    component: Layouts,
    redirect: `/${STATISTICS}/${SUMMARY}`,
    name: 'Common',
    meta: {
      title: 'Title_Common.ChaXun_TongJi', // '查詢統計',
      svgIcon: 'statistics',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
    },
    children: [
      {
        path: `${SUMMARY}`,
        component: () => retryImport(`${STATISTICS}-${SUMMARY}`),
        name: 'CommonDict',
        meta: {
          title: 'Title_Common.DuiZhang_Dan', // '對賬單',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: 'cost',
        component: () => retryImport(`${STATISTICS}-cost`),
        name: 'StatisticsCost',
        meta: {
          title: 'Title_Common.YaoPin_ShiYong_ChengBen_BaoGao', // '藥品使用成本報告',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
    ],
  },
  {
    path: `/${LOG}`,
    component: Layouts,
    redirect: `/${LOG}/${PRINTRECORD}`,
    name: 'Log',
    meta: {
      title: 'Title_Common.RiZhi', // '日誌',
      svgIcon: 'bug',
      roles: ['admin', 'editor'], // 可以在根路由中设置角色
      alwaysShow: true, // 将始终显示根菜单
    },
    children: [
      {
        path: `${PRINTRECORD}`,
        component: () => retryImport(`${LOG}-${PRINTRECORD}`),
        name: 'LogPrintrecord',
        meta: {
          title: 'Title_Common.DaYin_RiZhi', // '打印日誌',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
      {
        path: `${LOGINLOG}`,
        component: () => retryImport(`${LOG}-${LOGINLOG}`),
        name: 'LogLoginlog',
        meta: {
          title: 'Title_Common.DengLu_RiZhi', // '登錄日誌',
          roles: ['admin'], // 或者在子导航中设置角色
        },
      },
    ],
  },
]

const router = createRouter({
  history,
  routes: constantRoutes,
})

/** 重置路由 */
export function resetRouter() {
  // 注意：所有动态路由路由必须带有 Name 属性，否则可能会不能完全重置干净
  try {
    router.getRoutes().forEach((route) => {
      const { name, meta } = route
      if (name && Array.isArray(meta?.roles) && meta.roles.length) {
        router.hasRoute(name) && router.removeRoute(name)
      }
    })
  } catch {
    // 强制刷新浏览器也行，只是交互体验不是很好
    window.location.reload()
  }
}
async function retryImport(page) {
  try {
    // 加载页面资源
    console.log('retryImport =login= ', page === 'login')
    switch (page) {
      // case '403':
      //   return await import(`@/views/error-page/403.vue`)
      // case '404':
      //   return await import(`@/views/error-page/404.vue`)
      case 'login':
        return await import(`@/views/login/index.vue`)
      case 'home':
        return await import(`@/views/home/index.vue`)
      case 'clinic-list':
        return await import(`@/views/clinic/list/index.vue`) // 诊所列表
      case 'clinic-config':
        return await import(`@/views/clinic/config/index.vue`) // 诊所配置
      case 'clinic-source':
        return await import(`@/views/clinic/source/index.vue`) // 号源规则
      case 'clinic-slot':
        return await import(`@/views/clinic/slot/index.vue`) // 號源設定
      case 'clinic-role':
        return await import(`@/views/clinic/role/index.vue`) // 角色權限
      case 'user-employee':
        return await import(`@/views/user/employee/index.vue`) // 員工信息
      case 'user-patient':
        return await import(`@/views/user/patient/index.vue`) // 患者列表
      case 'user-promotion':
        return await import(`@/views/user/promotion/index.vue`) // 轉介碼
      case 'user-proxy':
        return await import(`@/views/user/proxy/index.vue`) // 授權管理
      case 'user-common':
        return await import(`@/views/user/common/index.vue`) // 常用設定
      case 'revenue-fee':
        return await import(`@/views/revenue/fee/index.vue`) // 收費設定
      case 'medication-list':
        return await import(`@/views/medication/list/index.vue`) // 藥品列表
      case 'medication-inventory':
        return await import(`@/views/medication/inventory/index.vue`) // 藥品庫存
      case 'medication-procurement':
        return await import(`@/views/medication/procurement/index.vue`) // 藥品採購
      case 'medication-stocktaking':
        return await import(`@/views/medication/stocktaking/index.vue`) // 藥品盤點
      case 'medication-adjustment':
        return await import(`@/views/medication/adjustment/index.vue`) // 藥品調整
      case 'medication-tracking':
        return await import(`@/views/medication/tracking/index.vue`) // 庫存追蹤
      case 'retail-drug':
        return await import(`@/views/retail/drug/index.vue`) // 藥品零售
      case 'retail-activities':
        return await import(`@/views/retail/activities/index.vue`) // 零售活動
      case 'project-acupuncture':
        return await import(`@/views/project/acupuncture/index.vue`) // 針灸管理
      case 'project-boning':
        return await import(`@/views/project/boning/index.vue`) // 推拿/正骨
      case 'project-cupping':
        return await import(`@/views/project/cupping/index.vue`) // 拔罐管理
      case 'project-disease':
        return await import(`@/views/project/disease/index.vue`) // 匹配藥物
      case 'discount-coupon':
        return await import(`@/views/discount/coupon/index.vue`) // 優惠券
      case 'discount-setmeal':
        return await import(`@/views/discount/setmeal/index.vue`) // 套票管理
      case 'discount-events':
        return await import(`@/views/discount/events/index.vue`) // 儲值活動
      case 'discount-client':
        return await import(`@/views/discount/client/index.vue`) // 儲值用戶
      case 'data-acupunctureMethod':
        return await import(`@/views/data/acupunctureMethod/index.vue`) // 针灸方法
      case 'data-acupuncturePosition':
        return await import(`@/views/data/acupuncturePosition/index.vue`) // 针灸位置
      case 'data-medicantFunc':
        return await import(`@/views/data/medicantFunc/index.vue`) // 药品功能
      case 'data-medicantBrand':
        return await import(`@/views/data/medicantBrand/index.vue`) // 药品品牌
      case 'data-payMethod':
        return await import(`@/views/data/payMethod/index.vue`) // 支付方式
      case 'data-memberType':
        return await import(`@/views/data/memberType/index.vue`) // 会员类别
      case 'data-labexamType':
        return await import(`@/views/data/labexamType/index.vue`) // 化验类型
      case 'data-labexam':
        return await import(`@/views/data/labexam/index.vue`) // 化验指标
      case 'data-exclusion':
        return await import(`@/views/data/exclusion/index.vue`) // 藥物互斥
      case 'data-sensitive':
        return await import(`@/views/data/sensitive/index.vue`) // 敏感禁忌
      case 'statistics-summary':
        return await import(`@/views/statistics/summary/index.vue`) // 對賬單
      case 'statistics-cost':
        return await import(`@/views/statistics/cost/index.vue`) // 藥品使用成本報告
      case 'log-printrecord':
        return await import(`@/views/log/printrecord/index.vue`) // 打印日誌
      case 'log-loginlog':
        return await import(`@/views/log/loginlog/index.vue`) // 登錄日誌
      default:
        return await import(`@/views/home/index.vue`)
      // return await import(`@/views/error-page/404.vue`)
    }
  } catch (err: any) {
    console.log('判断是否是资源加载错误，错误重试 == ', err)
    //  判断是否是资源加载错误，错误重试
    if (err.toString().indexOf('Failed to fetch dynamically imported module') > -1) {
      // todo
      window.location.reload()
      return
    }
    throw err
  }
}

export default router
